import React from "react";

import {  Container } from "react-bootstrap";
const Skills = () => {
  return (
    <Container>
      <Container className="Skills">
        <div class="skill-main">
          <div class="skills-left">
            <div class="skills-bar">
              <div class="info">
                <p>MERN Stack Development</p>
                <p>90%</p>
              </div>
              <div class="bar">
                <span class="html"></span>
              </div>
            </div>
            <div class="skills-bar">
              <div class="info">
                <p>PYTHON Programming</p>
                <p>70%</p>
              </div>
              <div class="bar">
                <span class="css"></span>
              </div>
            </div>
            <div class="skills-bar">
              <div class="info">
                <p>Data Structures & Algorithm</p>
                <p>75%</p>
              </div>
              <div class="bar">
                <span class="javaScript"></span>
              </div>
            </div>

            <div class="skills-bar">
              <div class="info">
                <p>JAVA programming</p>
                <p>70%</p>
              </div>
              <div class="bar">
                <span class="css"></span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Container>
  );
};
export default Skills;
